import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoNumberedSteps } from "@/components/seo/SeoNumberedSteps";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Gift } from "lucide-react";

const KomikNaUrodziny = () => (
  <SeoPageLayout title="Komik" titleAccent="na urodziny">
    <SeoSection title="Urodzinowy występ komediowy">
      <p>Szukasz oryginalnego prezentu urodzinowego? Profesjonalny komik na przyjęciu urodzinowym to niespodzianka, która rozbawi jubilata i wszystkich gości. Spersonalizowany występ oparty na historii solenizanta gwarantuje niezapomniane emocje i wspomnienia na lata.</p>
    </SeoSection>

    <SeoSection title="Rodzaje urodzinowych występów">
      <SeoStyledList items={[
        "Okrągłe urodziny - 30, 40, 50, 60 - humorystyczne podsumowanie dekad życia",
        "Urodziny-niespodzianka - komik pojawia się niespodziewanie dla jubilata",
        "Roast urodzinowy - przyjaciele i rodzina dostarczają materiał, komik go prezentuje",
        "Urodziny firmowe - szef lub pracownik świętuje w gronie współpracowników"
      ]} />
    </SeoSection>

    <SeoSection title="Jak przygotowujemy materiał urodzinowy?">
      <SeoNumberedSteps steps={[
        { title: "Rozmowa z bliskimi", description: "Rozmawiamy z organizatorem lub bliskimi jubilata, zbieramy zabawne historie." },
        { title: "Tworzenie materiału", description: "Komik tworzy unikatowy materiał, który jest jednocześnie osobisty i uniwersalny." },
        { title: "Niezapomniany występ", description: "Jubilat czuje się doceniony, a goście bawią się świetnie." },
      ]} />
    </SeoSection>

    <SeoSection title="Praktyczne informacje">
      <p>Występ urodzinowy trwa zazwyczaj 15-30 minut. Komik dostosowuje się do lokalizacji - restauracja, dom, sala bankietowa, ogródek. Potrzebujemy jedynie dostępu do prądu (jeśli korzystamy z nagłośnienia) i odrobiny przestrzeni scenicznej. Resztą zajmujemy się sami.</p>
      <SeoHighlightBox icon={Gift}>
        Komik na urodziny to prezent, który nie wymaga pakowania - wystarczy zarezerwować termin, a resztą zajmiemy się my!
      </SeoHighlightBox>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikNaUrodziny;
